import React, { PureComponent } from "react";
import { Icon } from "@vitalsource/vstui";

class NullCloud5 extends PureComponent {
  render() {
    return (
      <Icon {...this.props} height={53} width={81}>
        <g fill="none" fillRule="evenodd" fillOpacity="0.2">
          <g transform="translate(-1359 -188)" fill="#EAF7FC">
            <g transform="translate(-18 44)">
              <g transform="translate(0 68)">
                <path d="M1473.5897,108.073054 L1468.81013,108.073054 C1468.93175,107.437926 1469.00255,106.784651 1469.00255,106.115045 C1469.00255,100.228316 1464.12858,95.4548761 1458.11645,95.4548761 C1455.88369,95.4548761 1453.80976,96.1145018 1452.08254,97.2432149 C1451.77667,85.4643136 1441.33895,76 1428.49874,76 C1418.16993,76 1409.3968,82.1253553 1406.19831,90.6514942 C1404.28231,88.3523311 1401.77181,86.9459764 1399.01535,86.9459764 C1393.01139,86.9459764 1388.14287,93.5603802 1388.14287,101.719052 C1388.14287,103.997347 1388.53406,106.146801 1389.21206,108.073054 L1387.97677,108.073054 C1382.34222,108.073054 1377.73147,112.682268 1377.73147,118.314945 C1377.73147,123.947623 1382.34222,128.556837 1387.97677,128.556837 L1473.5897,128.556837 C1479.22425,128.556837 1483.8341,123.947623 1483.8341,118.314945 C1483.8341,112.682268 1479.22425,108.073054 1473.5897,108.073054" />
              </g>
            </g>
          </g>
        </g>
      </Icon>
    );
  }
}

NullCloud5.displayName = "NullCloud5";
NullCloud5.vstuiName = "Icon";

export default NullCloud5;
